import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6997eca8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "correct" }
const _hoisted_2 = { class: "bigtitle" }
const _hoisted_3 = {
  key: 0,
  class: "line1"
}
const _hoisted_4 = {
  key: 1,
  class: "line1"
}
const _hoisted_5 = {
  key: 2,
  class: "line2"
}
const _hoisted_6 = {
  key: 3,
  class: "line2"
}
const _hoisted_7 = { class: "dui" }
const _hoisted_8 = { class: "jiexi" }
const _hoisted_9 = { class: "daan" }
const _hoisted_10 = {
  key: 0,
  class: "answer"
}
const _hoisted_11 = {
  key: 1,
  class: "answer"
}
const _hoisted_12 = {
  key: 2,
  class: "answer"
}
const _hoisted_13 = {
  key: 3,
  class: "answer"
}
const _hoisted_14 = {
  key: 4,
  class: "answer"
}
const _hoisted_15 = {
  key: 5,
  class: "answer"
}
const _hoisted_16 = {
  key: 6,
  class: "answer"
}
const _hoisted_17 = { class: "dadesc" }
const _hoisted_18 = {
  key: 0,
  class: "desc"
}
const _hoisted_19 = {
  key: 1,
  class: "desc"
}
const _hoisted_20 = {
  key: 2,
  class: "desc"
}
const _hoisted_21 = {
  key: 3,
  class: "desc"
}
const _hoisted_22 = {
  key: 4,
  class: "desc"
}
const _hoisted_23 = {
  key: 5,
  class: "desc"
}
const _hoisted_24 = {
  key: 6,
  class: "desc"
}
const _hoisted_25 = { class: "ip" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paper" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("div", null, " Johnson M. Journal of allergy and clinical immunology 1998; 101(4): S434-S439. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        ($props.correct == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "太棒了"))
          : _createCommentVNode("", true),
        ($props.correct == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, "很遗憾"))
          : _createCommentVNode("", true),
        ($props.correct == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "继续探查"))
          : _createCommentVNode("", true),
        ($props.correct == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, "请再看下其它线索"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        ($props.correct == 1)
          ? (_openBlock(), _createBlock(_component_van_image, {
              key: 0,
              width: "2.4667rem",
              height: "3.08rem",
              src: require('../assets/dui.png')
            }, null, 8, ["src"]))
          : _createCommentVNode("", true),
        ($props.correct == 0)
          ? (_openBlock(), _createBlock(_component_van_image, {
              key: 1,
              width: "2.4667rem",
              height: "3.08rem",
              src: require('../assets/cuo.png')
            }, null, 8, ["src"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          ($props.postaimqus == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 正确答案：" + _toDisplayString($data.questions[$props.postaimqus].radioList[2].title), 1))
            : _createCommentVNode("", true),
          ($props.postaimqus == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 正确答案：" + _toDisplayString($data.questions[$props.postaimqus].radioList[2].title), 1))
            : _createCommentVNode("", true),
          ($props.postaimqus == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 正确答案：" + _toDisplayString($data.questions[$props.postaimqus].radioList[4].title), 1))
            : _createCommentVNode("", true),
          ($props.postaimqus == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 正确答案：" + _toDisplayString($data.questions[$props.postaimqus].radioList[0].title), 1))
            : _createCommentVNode("", true),
          ($props.postaimqus == 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, " 正确答案：" + _toDisplayString($data.questions[$props.postaimqus].radioList[4].title), 1))
            : _createCommentVNode("", true),
          ($props.postaimqus == 5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, " 答案解密1：" + _toDisplayString($data.questions[$props.postaimqus].radioList[3].title), 1))
            : _createCommentVNode("", true),
          ($props.postaimqus == 6)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, " 答案解密：" + _toDisplayString($data.questions[$props.postaimqus].radioList[4].title), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_17, [
          ($props.postaimqus == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, " 答案解析：" + _toDisplayString($data.questions[$props.postaimqus].desc), 1))
            : _createCommentVNode("", true),
          ($props.postaimqus == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 答案解析：" + _toDisplayString($data.questions[$props.postaimqus].desc), 1))
            : _createCommentVNode("", true),
          ($props.postaimqus == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, " 答案解析：" + _toDisplayString($data.questions[$props.postaimqus].desc), 1))
            : _createCommentVNode("", true),
          ($props.postaimqus == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, " 答案解析：" + _toDisplayString($data.questions[$props.postaimqus].desc), 1))
            : _createCommentVNode("", true),
          ($props.postaimqus == 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, " 答案解析：" + _toDisplayString($data.questions[$props.postaimqus].desc), 1))
            : _createCommentVNode("", true),
          ($props.postaimqus == 5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 答案解析：" + _toDisplayString($data.questions[$props.postaimqus].desc), 1))
            : _createCommentVNode("", true),
          ($props.postaimqus == 6)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, " 答案解析：" + _toDisplayString($data.questions[$props.postaimqus].desc), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(_component_van_image, {
        class: "footBtn",
        onClick: $options.nexStep,
        width: "5.64rem",
        height: "1.3333rem",
        src: require('../assets/jxbtn.png')
      }, null, 8, ["onClick", "src"]),
      _createVNode(_component_van_image, {
        class: "finger",
        width: "1.28rem",
        height: "1.28rem",
        src: require('../assets/dong.gif')
      }, null, 8, ["src"])
    ]),
    _hoisted_26
  ], 64))
}